/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-floating-promises */
import {
  CloseOutlined,
  CodeOutlined,
  DeleteOutlined,
  DownloadOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Descriptions,
  Divider,
  Form,
  Input,
  Modal,
  PageHeader,
  Popconfirm,
  Row,
  Segmented,
  Space,
  Tag,
  Typography,
  message,
  type InputRef,
} from "antd";
import Table, { type ColumnsType } from "antd/lib/table";
import { type FilterValue } from "antd/lib/table/interface";
import React, { type ChangeEvent, useEffect, useState, useRef } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { StatusTag } from "../components/StatusTag";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { v4 as uuidv4 } from "uuid";
import {
  midserviceInstansesListAsync,
  selectMidservicesList,
  setInstancesListCurrentPage,
  deleteInstanceAsync,
  selectPageReload,
  websocketUpdates,
  sendCommandToDeviceListAsync,
} from "../redux/slices/midservice/midserviceSlice";
import {
  type PaginationParams,
  type MidserviceType,
  MidserviceStatus,
  type WebosocketMessageType,
  type MessageType,
} from "../redux/slices/midservice/midserviceTypes";
import { timestampToReadable } from "../utils/time";
import moment from "moment";
import {
  getSalesStatisticsAsync,
  selectQtyStatistics,
  selectSalesStatistics,
  selectStatisticsLoading,
  selectTotalStatistics,
} from "../redux/slices/statistics/statisticsSlice";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip as ChartTooltip,
} from "recharts";
import { type SegmentedValue } from "antd/lib/segmented";
import { API } from "../api/Api";

import TableHeader from "../components/SearchFilter";
import { filtersToQueryString } from "../utils/filter";
import { getApiUrlWS } from "../utils/url";
import { type WebSocketHook } from "react-use-websocket/dist/lib/types";
import useWebSocket, { ReadyState } from "react-use-websocket";
import {
  selectCanUserEdit,
  selectCurrentUser,
} from "../redux/slices/user/userSlice";
import {
  findFilterInSearch,
  addfiltersToSearchString,
} from "../utils/tableUtils";
import SendCommandForm from "../components/SendCommandForm";
import yaml from "js-yaml";
import { defaultParamsYaml } from "../constants/defaultMethodParameters";
import { type FieldData } from "./MidservicePage/ConfigurationForm";
import { validateParams } from "../utils/yaml";

const { RangePicker } = DatePicker;
const { Text } = Typography;

type ValidateStatus = Parameters<typeof Form.Item>[0]["validateStatus"];

interface TTInfo {
  addressName?: string;
  networkLogin?: string;
  networkName?: string;
}

interface NumericStatisticsProps {
  ttInfo: TTInfo;
}

const NumericStatistics = ({ ttInfo }: NumericStatisticsProps): JSX.Element => {
  const total = useAppSelector(selectTotalStatistics);
  const qty = useAppSelector(selectQtyStatistics);
  const loading = useAppSelector(selectStatisticsLoading);

  return (
    <>
      <Col span={8}>
        <Card style={{ height: "100%" }} loading={loading}>
          <Descriptions title="Информация" column={1}>
            <Descriptions.Item label="Клиент">
              {`${ttInfo.networkLogin ?? "-"}/${ttInfo.networkName ?? "-"}`}
            </Descriptions.Item>
            <Descriptions.Item label="Торговая точка">
              {ttInfo.addressName ?? "-"}
            </Descriptions.Item>
          </Descriptions>
          <Divider></Divider>
          <Descriptions title="Статистика" column={1}>
            <Descriptions.Item label="Выручка">{total}</Descriptions.Item>
            <Descriptions.Item label="Количество чеков">
              {qty}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
    </>
  );
};

enum BarsType {
  all,
  total,
  qty,
}

export const AddressInstancesPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const salesStatistics = useAppSelector(selectSalesStatistics);
  const loading = useAppSelector(selectStatisticsLoading);
  const params = useParams();

  const [ttInfo, setTTInfo] = useState<TTInfo>({});

  const [dateRange, setDateRange] = useState<[moment.Moment, moment.Moment]>([
    moment(),
    moment(),
  ]);
  const [barsType, setBarsType] = useState<BarsType>(BarsType.all);
  console.log("salesStatistics", salesStatistics);
  const colorBar1 = "#91caff";
  const colorBar2 = "#1677ff";
  useEffect(() => {
    if (params?.addressId != null && params?.domain != null) {
      dispatch(
        getSalesStatisticsAsync({
          domain: params.domain,
          addressId: parseInt(params.addressId),
          dateFrom: dateRange[0].startOf("day").toISOString(true),
          dateTo: dateRange[1].endOf("day").toISOString(true),
        }),
      );
    }
  }, [dateRange, params?.addressId, params?.domain]);

  useEffect(() => {
    if (params?.addressId != null && params?.domain != null) {
      API.getTTInfo(params.domain, Number(params.addressId)).then((res) => {
        setTTInfo(res.data ?? {});
      });
    }
  }, []);

  const onDateRangeChange = (
    dates: any,
    formatString: [string, string],
  ): void => {
    console.log("new dates", dates);
    setDateRange(dates);
  };

  const onSegmentedChange = (value: SegmentedValue): void => {
    switch (value) {
      case "all":
        setBarsType(BarsType.all);
        break;
      case "total":
        setBarsType(BarsType.total);
        break;
      case "qty":
        setBarsType(BarsType.qty);
        break;

      default:
        break;
    }
  };

  const getBars = (): JSX.Element | undefined => {
    switch (barsType) {
      case BarsType.all:
        return (
          <>
            <Bar
              name="Выручка"
              yAxisId="left"
              dataKey="total"
              fill={colorBar1}
            />
            <Bar
              name="Количество"
              yAxisId="right"
              dataKey="qty"
              fill={colorBar2}
            />
          </>
        );
      case BarsType.total:
        return (
          <>
            <Bar
              name="Выручка"
              yAxisId="left"
              dataKey="total"
              fill={colorBar1}
            />
          </>
        );
      case BarsType.qty:
        return (
          <>
            <Bar
              name="Количество"
              yAxisId="right"
              dataKey="qty"
              fill={colorBar2}
            />
          </>
        );

      default:
        break;
    }
  };

  if (params?.addressId != null && params?.domain != null)
    return (
      <>
        <PageHeader
          style={{
            padding: 0,
            marginBottom: "1.25rem",
            borderBottom: "1px solid #d9d9d9",
          }}
          className="site-page-header"
          onBack={() => {
            window.history.back();
          }}
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          title={`TT: ${ttInfo?.addressName}`}
        />
        <Row gutter={16} style={{ marginBottom: "12pt" }}>
          <Col span={16}>
            <Card loading={loading}>
              <Row
                gutter={16}
                // style={{marginLeft: '10pt', marginRight: '10pt'}}
              >
                <Col flex={"auto"}>
                  <Text type="secondary">Продажи</Text>
                </Col>
                <Col flex={"none"}>
                  <Segmented
                    onChange={onSegmentedChange}
                    options={[
                      { label: "Вместе", value: "all" },
                      { label: "Выручка", value: "total" },
                      { label: "Кол-во", value: "qty" },
                    ]}
                  />
                </Col>
                <Col flex={"none"}>
                  <RangePicker
                    value={dateRange}
                    onChange={onDateRangeChange}
                    allowClear={false}
                  />
                </Col>
              </Row>

              <ResponsiveContainer
                width="100%"
                height="25%"
                minHeight={"200pt"}
              >
                <BarChart
                  width={500}
                  // style={{height: "200pt"}}
                  // height={"5%"}
                  data={salesStatistics}
                  margin={{
                    top: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="ts" />
                  <YAxis yAxisId="left" orientation="left" stroke={colorBar1} />
                  <YAxis
                    yAxisId="right"
                    orientation="right"
                    stroke={colorBar2}
                  />
                  <ChartTooltip />
                  <Legend />
                  {getBars()}
                </BarChart>
              </ResponsiveContainer>
            </Card>
          </Col>

          <NumericStatistics ttInfo={ttInfo} />
        </Row>

        <InstancesTable
          startSearch={`domain:${params.domain}`}
          constFilters={{
            addressId: [params.addressId] as FilterValue,
          }}
        />
      </>
    );
  return <></>;
};

const InstancesPage: React.FC = () => {
  return <InstancesTable />;
};

interface InstancesTableProps {
  constFilters?: Record<string, FilterValue | null>;
  startSearch?: string | null;
}

const downloadInstancesReport = (): void => {
  console.log("downloadInstancesFile");
  API.downloadInstancesFile()
    .then((response) => {
      console.log("downloadInstancesFile response", response);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "devices.csv");
      document.body.appendChild(link);
      link.click();
    })
    .catch((error) => {
      console.log("downloadInstancesFile error", error);
      message.error(error);
    });
};

const searchToFilters = (
  search: string | null,
): Record<string, FilterValue | null> => {
  const filters: Record<string, FilterValue | null> = {
    domain: null,
    instanceType: null,
    status: null,
  };

  if (search == null) {
    return filters;
  }

  filters.domain = findFilterInSearch(
    "domain",
    ["gamma", "partner", "orbit"],
    search,
  );
  filters.instanceType = findFilterInSearch(
    "type",
    ["KKM", "MIDSERVICE"],
    search,
  );
  filters.online = findFilterInSearch("status", ["ONLINE", "OFFLINE"], search);

  return filters;
};

const InstancesTable: React.FC<InstancesTableProps> = ({
  constFilters = { addressId: null },
  startSearch = null,
}: InstancesTableProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const midservicesList = useAppSelector(selectMidservicesList);
  const pageReload = useAppSelector(selectPageReload);
  const dispatch = useAppDispatch();
  const page: number = Number(searchParams.get("page") ?? 1);
  const pageSize: number = Number(searchParams.get("limit") ?? 10);
  const search: string | null = searchParams.get("search") ?? startSearch;
  const [openPopupId, setOpenPopupId] = useState<number | null>(null);
  const user = useAppSelector(selectCurrentUser);
  const canUserEdit = useAppSelector(selectCanUserEdit);
  const currentUser = useAppSelector(selectCurrentUser);
  const [form] = Form.useForm();
  const [params, setParams] = useState<{
    value: string;
    validateStatus?: ValidateStatus;
    errorMsg?: string | null;
  }>({
    value: "",
  });
  const [methods, setMethods] = useState<any[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [allRowsSelected, setAllRowsSelected] = useState<boolean>(false);

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys: React.Key[], rows: any[]) => {
      setSelectedRowKeys(keys);
      setSelectedRows(rows);
    },
    onSelectAll: (selected: boolean) => {
      setAllRowsSelected(selected);
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = (): void => {
    if (methods.length === 0) {
      API.getInstanceMethods().then(({ data }) => {
        setMethods(data.map((v: string) => ({ value: v, label: v })));
      });
    }
    setIsModalOpen(true);
  };

  const handleOk = (): void => {
    form.submit();
    setIsModalOpen(false);
  };

  const handleCancel = (): void => {
    setIsModalOpen(false);
  };

  const messages: WebosocketMessageType[] = [];

  const { readyState }: WebSocketHook<MessageEvent<string>> = useWebSocket(
    `${getApiUrlWS()}/api/v1/ws/updates?user_id=${user.id}`,
    {
      shouldReconnect: (closeEvent) => true,
      reconnectAttempts: 5,
      reconnectInterval: 3,
      onMessage(event) {
        console.log("message from server", event.data);
        if (event.data != null) {
          const websocketMessage: WebosocketMessageType = JSON.parse(
            event.data,
          );
          if (openPopupId === null) {
            dispatch(websocketUpdates(websocketMessage));
          } else {
            messages.push(websocketMessage);
          }
        }
      },
      filter: (message) => false,
    },
  );

  useEffect(() => {
    const connectionStatus = {
      [ReadyState.CONNECTING]: "Connecting",
      [ReadyState.OPEN]: "Open",
      [ReadyState.CLOSING]: "Closing",
      [ReadyState.CLOSED]: "Closed",
      [ReadyState.UNINSTANTIATED]: "Uninstantiated",
    }[readyState];
    console.log("readyState", connectionStatus);
  }, [readyState]);

  console.log("constFilters", constFilters);

  const [filter, setFilter] = useState<Record<string, FilterValue | null>>(
    searchToFilters(search),
  );

  console.log("filter", filter);
  const [searchString, setSearchString] = useState<string>(search ?? "");

  useEffect(() => {
    console.log("useEffect of pageReload");
    if (searchParams.get("page") == null || searchParams.get("limit") == null) {
      setSearchParams({
        page: "1",
        limit: "10",
        ...Object.fromEntries(searchParams),
      });
    }
    const instancesListParams: PaginationParams = {
      page,
      limit: pageSize,
      filter: filtersToQueryString(constFilters),
      search,
    };
    dispatch(midserviceInstansesListAsync(instancesListParams));
  }, [pageReload]);

  interface ColorfulRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
    index: number;
    instance: MidserviceType;
  }

  const ColorfulRow = ({
    index,
    instance,
    className,
    style,
    ...restProps
  }: ColorfulRowProps): JSX.Element => {
    let styles = {};
    if (instance?.online === MidserviceStatus.OFFLINE) {
      styles = { backgroundColor: "#f0f0f0", color: "#8c8c8c" };
    }
    return <tr style={styles} {...restProps} />;
  };

  const components = {
    body: {
      row: ColorfulRow,
    },
  };

  const searchInputRef = useRef<InputRef | null>(null);

  const handleHeaderClick = (): void => {
    searchInputRef.current?.focus();
  };

  const dispatchMessages = (): void => {
    for (const message of messages) {
      dispatch(websocketUpdates(message));
    }
    messages.splice(0);
  };

  const handleOpenPopup = (id: number): void => {
    setOpenPopupId(id);
  };

  const handleClosePopup = (): void => {
    setOpenPopupId(null);
    dispatchMessages();
  };

  const createSearchString = (mnemonic: string): void => {
    setSearchString((val: string) => {
      if (val.trim() === "") {
        return `${mnemonic}:`;
      }
      if (val.includes(mnemonic)) {
        return val;
      }
      return val + ` and ${mnemonic}:`;
    });
    handleHeaderClick();
  };

  const columns: ColumnsType<MidserviceType> = [
    {
      title: (
        <TableHeader
          title="Идентификатор"
          tooltipTitle="id:<текст>"
          onClickFn={createSearchString}
          mnemonic="id"
        ></TableHeader>
      ),
      dataIndex: "deviceId",
      key: "deviceId",
      render: (text, record) => (
        <Space size="middle">
          <Link to={`/instances/${record.id}`} key="list-loadmore-edit">
            {text}
          </Link>
        </Space>
      ),
    },
    {
      title: (
        <TableHeader
          title="Домен"
          tooltipTitle="domain:<gamma>, <partner> или <orbit>"
          onClickFn={createSearchString}
          mnemonic="domain"
          additionalIcon={false}
        ></TableHeader>
      ),
      dataIndex: "domain",
      key: "domain",
      filters: [
        {
          text: "gamma",
          value: "gamma",
        },
        {
          text: "partner",
          value: "partner",
        },
        {
          text: "orbit",
          value: "orbit",
        },
      ],
      filteredValue: filter.domain ?? null,
    },
    {
      title: (
        <TableHeader
          title="Название"
          tooltipTitle="name:<текст>"
          onClickFn={createSearchString}
          mnemonic="name"
        ></TableHeader>
      ),
      dataIndex: "name",
      key: "name",
    },
    {
      title: (
        <TableHeader
          title="Учетная запись"
          tooltipTitle="login:<текст>"
          onClickFn={createSearchString}
          mnemonic="login"
        ></TableHeader>
      ),
      dataIndex: "networkLogin",
      key: "login",
    },
    {
      title: (
        <TableHeader
          title="Клиент"
          tooltipTitle="client:<текст>"
          onClickFn={createSearchString}
          mnemonic="client"
        ></TableHeader>
      ),
      dataIndex: "networkName",
      key: "client",
    },
    {
      title: (
        <TableHeader
          title="Торговая точка"
          tooltipTitle="tradepoint:<текст>"
          onClickFn={createSearchString}
          mnemonic="tradepoint"
        ></TableHeader>
      ),
      dataIndex: "address",
      key: "address",
      render: (text, record) => {
        if (record.addressId != null) {
          return (
            <Link
              target="_blank"
              to={`/instances/tt/${record.domain}/${record.addressId}`}
            >
              {text}
            </Link>
          );
        }
        return text;
      },
    },
    {
      title: (
        <TableHeader
          title="Последнее отключение"
          tooltipTitle="lastonline:<год-месяц-число>"
          onClickFn={createSearchString}
          mnemonic="lastonline"
        ></TableHeader>
      ),
      dataIndex: "lastConnectionDatetime",
      key: "lastConnectionDatetime",
      render: (text) => timestampToReadable(text),
    },
    {
      title: (
        <TableHeader
          title="Тип"
          tooltipTitle="type:<KKM> или <MIDSERVICE>"
          onClickFn={createSearchString}
          mnemonic="type"
          additionalIcon={false}
        ></TableHeader>
      ),
      dataIndex: "instanceType",
      key: "instanceType",
      filters: [
        {
          text: "KKM",
          value: "KKM",
        },
        {
          text: "MIDSERVICE",
          value: "MIDSERVICE",
        },
      ],
      filteredValue: filter.instanceType ?? null,
      render: (text) => <Tag>{text}</Tag>,
    },
    {
      title: (
        <TableHeader
          title="Версия"
          tooltipTitle="version:<текст>"
          onClickFn={createSearchString}
          mnemonic="version"
        ></TableHeader>
      ),
      dataIndex: "version",
      key: "version",
    },
    {
      title: (
        <TableHeader
          title="Статус"
          tooltipTitle="status:<ONLINE> или <OFFLINE>"
          onClickFn={createSearchString}
          mnemonic="status"
          additionalIcon={false}
        ></TableHeader>
      ),
      dataIndex: "online",
      key: "online",
      filters: [
        {
          text: "ONLINE",
          value: "ONLINE",
        },
        {
          text: "OFFLINE",
          value: "OFFLINE",
        },
      ],
      filteredValue: filter.online ?? null,
      render: (text) => <StatusTag status={text} />,
    },
    {
      title: "Управление",
      key: "action",
      fixed: "right",
      width: 100,

      render: (_, record) => (
        <>
          <Popconfirm
            key={record.id}
            okText={"Да"}
            cancelText={"Отменить"}
            onCancel={() => {
              handleClosePopup();
            }}
            open={openPopupId === record.id}
            title="Удалить устройство?"
            onConfirm={async () => {
              dispatchMessages();
              await dispatch(deleteInstanceAsync(record.id));
            }}
          >
            <DeleteOutlined
              onClick={() => {
                handleOpenPopup(record.id);
              }}
              style={{ color: "#f5222d" }}
            />
          </Popconfirm>
        </>
      ),
    },
  ];

  const onTableChange = (
    pagination: any,
    filters: Record<string, FilterValue | null>,
    sorter: any,
    extra: any,
  ): void => {
    console.log("onTableChange", pagination, filters, sorter, extra);
    console.log("filter onTableChange before", filter);

    const searchParams: Record<string, string> = {
      page: pagination.current,
      limit: pagination.pageSize,
    };

    const currentSearch: string = addfiltersToSearchString(
      filters,
      searchString,
    );

    if (currentSearch !== "") {
      searchParams.search = currentSearch;
    }

    const instancesListParams: PaginationParams = {
      page: pagination.current,
      limit: pagination.pageSize,
      filter: filtersToQueryString(constFilters),
      search: currentSearch,
    };
    dispatch(midserviceInstansesListAsync(instancesListParams));

    dispatch(setInstancesListCurrentPage(pagination.current));

    const newFilter: Record<string, FilterValue | null> = {
      ...filters,
    };
    setFilter(newFilter);
    setSearchString(currentSearch);
    setSearchParams(searchParams);

    console.log("filter onTableChange after", newFilter);
  };

  const onSearchChange = (value: ChangeEvent<HTMLInputElement>): void => {
    const currentSearch = value.target.value;
    console.log("search", currentSearch);
    setSearchString(currentSearch);

    const filters = searchToFilters(currentSearch);
    setFilter(filters);

    const instancesListParams: PaginationParams = {
      page: 1,
      limit: pageSize,
      filter: filtersToQueryString(constFilters),
      search: currentSearch,
    };
    dispatch(midserviceInstansesListAsync(instancesListParams));

    const newSearchParams: Record<string, string> = {
      ...Object.fromEntries(searchParams),
      search: currentSearch,
    };
    if (newSearchParams.search === "") delete newSearchParams.search;
    setSearchParams(newSearchParams);
  };

  const dropFilters = (): void => {
    const instancesListParams: PaginationParams = {
      page: 1,
      limit: pageSize,
      filter: filtersToQueryString(constFilters),
      search: startSearch ?? "",
    };
    dispatch(midserviceInstansesListAsync(instancesListParams));

    const filters = searchToFilters(startSearch);
    setFilter(filters);

    setSearchString(startSearch ?? "");
    setSearchParams({
      page: "1",
      limit: pageSize.toString(),
    });
  };

  const getTableDataSource = (): any[] => {
    return midservicesList.content.map((item: MidserviceType) => ({
      ...item,
      key: item.id,
    }));
  };

  const onFinish = (values: any): void => {
    console.log("Success:", values);
    try {
      const message: MessageType = {
        instanceId: 0,
        callId: uuidv4(),
        requestMethod: values.method,
        requestParams: values.params != null ? yaml.load(values.params) : null,
        requestTime: Date.now(),
        authorId: currentUser.id,
        authorLogin: currentUser.login,
      };
      console.log("Success message:", message);
      let params;
      if (allRowsSelected) {
        params = {
          search: searchString,
          message,
        };
      } else {
        const devices: Record<string, Record<string, string>> = {};
        selectedRows.forEach((item) => {
          devices[item.id] = { device_id: item.deviceId, domain: item.domain };
        });
        params = {
          devices,
          message,
        };
      }
      dispatch(sendCommandToDeviceListAsync(params));
    } catch (err) {
      console.log("err", err);
    }
  };
  const onFinishFailed = (errorInfo: any): void => {
    console.log("Failed:", errorInfo);
  };
  const onMethodFieldsChange = (value: string): void => {
    try {
      const defaultValue: string = defaultParamsYaml[value];
      setParams({ ...params, value: defaultValue });
      const newFields: FieldData[] = [
        { name: "method", value },
        { name: "params", value: defaultValue },
      ];
      form.setFields(newFields);
    } catch (err) {}
  };
  const onParamsChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    const value = event.target.value;
    setParams({
      ...validateParams(value),
      value,
    });
  };

  return (
    <>
      <Row style={{ marginBottom: "1rem" }}>
        <Col flex="auto">
          <Input
            ref={searchInputRef}
            addonBefore={<SearchOutlined />}
            placeholder="Поиск по всем полям"
            allowClear
            onChange={onSearchChange}
            value={searchString}
          />
        </Col>
        <Col span={6} offset={1} flex="none">
          <Button onClick={dropFilters} icon={<CloseOutlined />}>
            Сбросить фильтры{" "}
          </Button>
        </Col>
        <Col flex="none">
          <Button
            onClick={downloadInstancesReport}
            icon={<DownloadOutlined />}
          ></Button>
        </Col>
        <Col flex="none">
          <Button
            disabled={rowSelection.selectedRowKeys?.length === 0}
            onClick={showModal}
            icon={<CodeOutlined />}
          ></Button>
        </Col>
        <Modal
          title="Массовая отправка команды"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          okText="Отправить"
          cancelText="Отмена"
          okButtonProps={{ disabled: !canUserEdit }}
        >
          <SendCommandForm
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            params={params}
            onMethodFiedlsChange={onMethodFieldsChange}
            onParamsChange={onParamsChange}
            methods={methods}
            confirmButton={false}
          />
        </Modal>
      </Row>
      <Table
        size="small"
        rowSelection={{ type: "checkbox", ...rowSelection }}
        onChange={onTableChange}
        components={components}
        onRow={(instance, index) => {
          if (typeof index !== "undefined") {
            // const instance = midservicesList.content[index]
            const attr: any = {
              index,
              instance,
            };
            return attr as React.HTMLAttributes<any>;
          }
          return {} satisfies React.HTMLAttributes<any>;
        }}
        pagination={{
          // onChange: onPaginationChange,
          showSizeChanger: true,
          pageSize: midservicesList.pageSize,
          total: midservicesList.totalRecord,
          current: midservicesList.pageNumber,
        }}
        scroll={{ x: true }}
        columns={columns}
        dataSource={getTableDataSource()}
      />
    </>
  );
};

export default InstancesPage;
